import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const forcePasswordChangeGuard: CanActivateChildFn = (
  childRoute: ActivatedRouteSnapshot,
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isPasswordChangeRequired()) {
    return true;
  }

  if (childRoute.routeConfig?.path === 'change-password') {
    return true;
  }

  return router.createUrlTree(['/change-password']);
};
